import xss from "xss";

import RESPONSE_HEADER from "../enums/RESPONSE_HEADER";
import CONFIG from "../../config";

export function processResponse(orderResponse, kundeId, isMAShop = true) {
  let defaultMessage = "UNBEKANNT";
  let headerStatus = null;
  let errorNr = "";
  
  if (CONFIG.isKundenShop() && CONFIG.isVerseNeo()) {
    defaultMessage = "VNEO_UNBEKANNT";
  }
  if (orderResponse && orderResponse.data && orderResponse.data.header) {
    headerStatus = orderResponse.data.header.status;
    errorNr = orderResponse.data.header.errorNr ? ` (${xss(orderResponse.data.header.errorNr)})` : "";
  }
  switch (headerStatus) {
    case RESPONSE_HEADER.STATUS.SUCCESSFUL:
      return ({ path: CONFIG.LINK_DANKE + kundeId });
    case RESPONSE_HEADER.STATUS.NO_SUCCESS:
      if (isMAShop) {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.NO_SUCCESS_MITARBEITER,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.NO_SUCCESS_MITARBEITER
          }
        });
      } else {
        if (CONFIG.isKundenShop() && CONFIG.isVerseNeo()) {
          return ({
            error: {
              messageTitle: RESPONSE_HEADER.ERRORTITEL.NO_SUCCESS_KUNDEN,
              messageText: RESPONSE_HEADER.ERRORMESSAGE.VNEO_UNBEKANNT
            }
          });
        } else {
          return ({
            error: {
              messageTitle: RESPONSE_HEADER.ERRORTITEL.NO_SUCCESS_KUNDEN,
              messageText: RESPONSE_HEADER.ERRORMESSAGE.NO_SUCCESS_KUNDEN
            }
          });
        }
      }
    case RESPONSE_HEADER.STATUS.HOSTERROR:
      if (isMAShop) {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.HOST_VALIDIERUNG_MITARBEITER,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.HOST_VALIDIERUNG_MITARBEITER
          }
        });
      } else {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.HOST_VALIDIERUNG_KUNDEN,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.HOST_VALIDIERUNG_KUNDEN
          }
        });
      }
    case RESPONSE_HEADER.STATUS.OK_WITH_WARNING:
      return processWarnings(xss(orderResponse.data.header.errorNr), kundeId, isMAShop);
    case RESPONSE_HEADER.STATUS.ERROR:
      if (Array.isArray(RESPONSE_HEADER.ERRORMESSAGE[defaultMessage])) {
        const messageText = [...RESPONSE_HEADER.ERRORMESSAGE[defaultMessage], new Date().toLocaleString("de-DE") + errorNr];
        return ({ error: { messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT, messageText } });
      }
      return ({
        error: {
          messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT,
          messageText: new Date().toLocaleString("de-DE") + errorNr + ": " + RESPONSE_HEADER.ERRORMESSAGE[defaultMessage]
        }
      });
    default:
      return ({
        error: {
          messageTitle: "Unbekannter Status",
          messageText: new Date().toLocaleString("de-DE") + errorNr + ": Der zurückgegebene Status ist unbekannt."
        }
      });
  }
}

function processWarnings(errorNr, kundeId, isMAShop = true) {
  let defaultMessage = "UNBEKANNT";
  if (CONFIG.isKundenShop() && CONFIG.isVerseNeo()) {
    defaultMessage = "VNEO_UNBEKANNT";
  }
  switch (errorNr) {
    case RESPONSE_HEADER.ERRORNUMMER.HOST_TIME_OUT:
      if (isMAShop) {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.TIMEOUT_MITARBEITER,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.TIMEOUT_MITARBEITER
          }
        });
      } else {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.TIMEOUT_KUNDEN,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.TIMEOUT_KUNDEN
          }
        });
      }
    case RESPONSE_HEADER.ERRORNUMMER.PDF_GENERIERUNG:
      if (isMAShop) {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.PDF_GENERIERUNG_MITARBEITER,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.PDF_GENERIERUNG_MITARBEITER
          }
        });
      } else {
        return ({
          error: {
            messageTitle: RESPONSE_HEADER.ERRORTITEL.PDF_GENERIERUNG_KUNDEN,
            messageText: RESPONSE_HEADER.ERRORMESSAGE.PDF_GENERIERUNG_KUNDEN
          }
        });
      }
    case RESPONSE_HEADER.ERRORNUMMER.MAILVERSAND:
      if (isMAShop) {
        return ({ path: CONFIG.LINK_DANKE + kundeId, message: RESPONSE_HEADER.ERRORMESSAGE.MAILVERSAND_MITARBEITER });
      } else {
        return ({ path: CONFIG.LINK_DANKE + kundeId, message: RESPONSE_HEADER.ERRORMESSAGE.MAILVERSAND_KUNDEN });
      }
    default:
      const errorNrText = errorNr ? ` (${errorNr})` : "";
      if (Array.isArray(RESPONSE_HEADER.ERRORMESSAGE[defaultMessage])) {
        const messageText = [...RESPONSE_HEADER.ERRORMESSAGE[defaultMessage], new Date().toLocaleString("de-DE") + errorNrText];
        return ({ error: { messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT, messageText } });
      }
      return ({
        error: {
          messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT,
          messageText: new Date().toLocaleString("de-DE") + errorNrText + ": " + RESPONSE_HEADER.ERRORMESSAGE[defaultMessage]
        }
      });
  }

}

export function processOrderError(error) {
  let defaultMessage = "UNBEKANNT";
  if (CONFIG.isKundenShop() && CONFIG.isVerseNeo()) {
    defaultMessage = "VNEO_UNBEKANNT";
  }
  console.error(error);
  if (Array.isArray(RESPONSE_HEADER.ERRORMESSAGE[defaultMessage])) {
    const messageText = [...RESPONSE_HEADER.ERRORMESSAGE[defaultMessage], new Date().toLocaleString("de-DE")];
    return ({ error: { messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT, messageText } });
  }
  return ({
    error: {
      messageTitle: RESPONSE_HEADER.ERRORTITEL.UNBEKANNT,
      messageText: new Date().toLocaleString("de-DE") + ": " + RESPONSE_HEADER.ERRORMESSAGE[defaultMessage]
    }
  });
}
